
import Vue from 'vue';
import axios from "axios";

function compare(a, b) {
  if (a.name.toLowerCase() < b.name.toLowerCase())
    return -1;
  if (a.name.toLowerCase() > b.name.toLowerCase())
    return 1;
  return 0;
}

export default Vue.extend({
  name: 'TaskList',
  data() {
    return {
      landCountryID: "Russia",
      typeId: 1,
      id: "",
      name: "",
      errorMessage: "",
      isSearchDisabled: false,
      isSearchError: false,
      tasks: [],
      portalUrl: {
        "ru": "wowworks.ru",
        "by": "wowworks.by",
        "de": "de.wowworks.org",
      },
    }
  },
  methods: {

    onEmptySearch(search, loading) {
    },

    search() {
      localStorage.setItem('landCountryID', this.landCountryID);
      localStorage.setItem('typeId', this.typeId.toString());

      this.tasksSearch();
    },

    tasksSearch() {

      this.isSearchDisabled = true;

      if (this.tasks) {
        this.tasks.splice(0);
      }

      axios.get(`/tasks/search`, {
        params: {
          land_country_id: this.landCountryID,
          type_id: this.typeId,
          id: this.id ? this.id : 0,
          name: this.name,
        }
      })
          .then((res) => {
            console.log(res.data);

            let tasks = res.data;

            if (tasks) {
              tasks.forEach(t => {
                t.link = 'https://curator.' + this.portalUrl[t.country_id] + '/task/' + t.external_id;
                if (t.type_id === 2) {
                  t.link = 'https://curator.' + this.portalUrl[t.country_id] + '/cleaning/project/' + t.external_project_id + '/object/' + t.external_id + '/calendar';
                }

                t.link_invoice = 'https://wowworks.app/invoices/' + t.country_id + '/' + t.invoice_external_id;


                this.tasks.push(t);
              })

            }


          })
          .catch((error) => {
            console.log(error);
            this.errorMessage = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            this.isSearchDisabled = false;
            // loading(false);
          });

    },

  },

  created() {
    document.title = 'Задания';
    let landCountryID = localStorage.getItem('landCountryID');

    if (landCountryID != null) {
      this.landCountryID = landCountryID
    } else {
      this.landCountryID = "Russia";
      localStorage.setItem('landCountryID', this.landCountryID);
    }

    let typeId = localStorage.getItem('typeId');

    if (typeId != null) {
      this.typeId = parseInt(typeId)
    } else {
      this.typeId = 1;
      localStorage.setItem('typeId', this.typeId.toString());
    }

    // this.tasksSearch();
  },

});
